export { default } from './DocumentHeader'
